import { render, staticRenderFns } from "./NisScoreRings.vue?vue&type=template&id=590d84e4&scoped=true"
import script from "./NisScoreRings.vue?vue&type=script&lang=js"
export * from "./NisScoreRings.vue?vue&type=script&lang=js"
import style0 from "./NisScoreRings.vue?vue&type=style&index=0&id=590d84e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d84e4",
  null
  
)

export default component.exports